const fetchAllForms = (forms) => {
  return {
    type: "FETCH_ALL_ACTIONS",
    forms,
  };
};

export default {
  fetchAllForms,
};
